// Field map for page 1 of the "Demande SPW Derogation" form (V1.1B layout).
// Coordinates are in PDF points (origin top-left, matching pdfplumber `top`).
// Page 1 size: 595 x 842 pt.
export const PAGE_W = 595;
export const PAGE_H = 842;
export const FONT_SIZE = 9;

// Simple single-line text fields (dotted fill-in lines + signature box + section 4 motif).
export const TEXT_FIELDS = [
  // "Le soussigné" block
  { id: "nom_prenom", x: 80, top: 198, w: 240, h: 14 },
  { id: "fonction", x: 372, top: 198, w: 205, h: 14 },
  { id: "date_demande", x: 155, top: 244, w: 165, h: 14 },
  // Section 1 — movement table data row (pre-filled from the flight)
  { id: "mv_datetime", x: 17, top: 373, w: 123, h: 18 },
  { id: "mv_compagnie", x: 144, top: 373, w: 149, h: 18 },
  { id: "mv_type", x: 297, top: 373, w: 184, h: 18 },
  { id: "mv_immat", x: 485, top: 373, w: 97, h: 18 },
  // Section 4 — free-text motif lines (editable)
  { id: "motif_0", x: 18, top: 712, w: 557, h: 15 },
  { id: "motif_1", x: 18, top: 732, w: 557, h: 15 },
  { id: "motif_2", x: 18, top: 752, w: 557, h: 15 },
  { id: "motif_3", x: 18, top: 774, w: 557, h: 15 },
  { id: "motif_4", x: 18, top: 794, w: 557, h: 15 },
];

// Signature box (drawn signature, embedded as PNG).
export const SIGNATURE_FIELD = { id: "signature", x: 372, top: 236, w: 206, h: 34 };

// Section 2 — "Historique des rotations" table grid (empty cells to fill).
// 8 columns: Numéro | Départ(A destination de, Heure planifiée, Heure estimée) |
//            Arrivée(En provenance de, Heure planifiée, Heure estimée) | Code IATA
const ROT_COL_X = [15, 66, 142, 210, 296, 373, 440, 523];
const ROT_COL_END = [65, 142, 209, 295, 372, 439, 522, 584];
const ROT_ROW_TOP = [502, 523, 544, 564];
export const ROTATION_FIELDS = [];
ROT_ROW_TOP.forEach((top, r) => {
  ROT_COL_X.forEach((x, c) => {
    ROTATION_FIELDS.push({
      id: `rot_${r}_${c}`,
      x: x + 1,
      top: top,
      w: ROT_COL_END[c] - x - 2,
      h: 20,
    });
  });
});

export const ALL_TEXT_FIELDS = [...TEXT_FIELDS, ...ROTATION_FIELDS];
